import React from "react";
import Spinner from "./Spinner";

interface ButtonProps {
  primary?: boolean;
  loading?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  danger?: boolean;
  icon?: React.ReactNode;
  animate?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  primary = false,
  loading = false,
  children,
  onClick,
  disabled = false,
  className = "",
  danger = false,
  icon = null,
  animate = false,
}) => {
  const baseClasses =
    "px-4 py-2 rounded-md font-medium";

  const primaryClasses =
    "bg-primary text-text";

  const secondaryClasses =
    "bg-transparent text-primary border border-primary hover:bg-neutral-lighter focus:ring-primary-light";

  const dangerClasses =
    "border border-text-dark text-text-dark hover:bg-neutral-darkest focus:ring-text-dark";

  const disabledClasses = "opacity-50 cursor-not-allowed";


  const iconToRender = loading ? null : icon;
  const shouldAnimate = animate;

  return (
    <button
      className={`${baseClasses} ${danger ? dangerClasses : primary ? primaryClasses : secondaryClasses} ${disabled ? disabledClasses : ""} ${className} relative group`}
      onClick={onClick}
      disabled={disabled}
    >
      <div
        className={`flex items-center transition-all duration-500 ease-in-out ${shouldAnimate ? "w-min group-hover:w-auto" : ""}`}
      >
        {loading ? <Spinner /> : null}
        {iconToRender && (
          <div className="h-5 w-5 flex items-center">{iconToRender}</div>
        )}
        {children && (
          <span
            className={`${iconToRender && !shouldAnimate ? "ml-2" : ""} ${shouldAnimate
              ? "transition-all duration-700 ease-in-out max-w-0 w-0 overflow-hidden group-hover:max-w-[200px] group-hover:w-auto group-hover:ml-2"
              : ""
              }`}
          >
            {children}
          </span>
        )}
      </div>
    </button>
  );
};

export default Button;
